export default {
    create_edit_dashboard_new: "Create Dashboard",
    create_edit_dashboard_edit: "Edit Dashboard",
    create_edit_dashboard_name: "Dashboard Name",
    create_edit_dashboard_label: "Dashboard",
    create_edit_dashboard_create_success_message: "Dashboard has been created",
    create_edit_dashboard_edit_success_message: "Dashboard has been edited",
}